<template>
  <DrawSettingTable ref="DrawSettingTable" :trStatus="trStatus" :columns="columns" :data="data" />
</template>

<script>
import delMarkPeriod from '@/mixins/del-mark-period'
const GamePropTimer = () => import('@/views/game-lobby/components/GamePropTimer')
export default {
  components: {
    DrawSettingTable: () => import('../components/DrawSettingTable'),
    GamePropTimer
  },
  mixins: [delMarkPeriod],
  props: {
    data: Object
  },
  data () {
    return {
      trStatus: false
    }
  },
  computed: {
    columns () {
      return [
        {
          title: '期数',
          align: 'center',
          key: 'period',
          width: 120,
          render: (h, params) => {
            return h('span', params.row.period)
          }
        },
        {
          title: '赛事开奖时间',
          align: 'center',
          key: 'endate',
          width: 160,
          render: (h, params) => {
            return h(GamePropTimer, {
              props: {
                data: params.row,
                row: 'endate'
              }
            })
          }
        },
        {
          title: '剩余设定时间',
          align: 'center',
          key: 'timeLoding',
          width: 120,
          render: (h, params) => {
            return h(GamePropTimer, {
              props: {
                data: params.row,
                row: 'timeLoading'
              },
              on: {
                trcolor: (val) => {
                  if (params.index === 0) this.trStatus = val
                },
                timeOut: () => {
                  this.$refs.DrawSettingTable.reload()
                }
              }
            })
          }
        },
        {
          title: '冠军',
          align: 'center',
          key: 'ball',
          render: (h, params) => {
            let ballNum = params.row.mark[0] == '-' ? '未指定' : params.row.mark[0]
            return h('span', ballNum)
          }
        },
        {
          title: '亚军',
          align: 'center',
          key: 'ball',
          render: (h, params) => {
            let ballNum = params.row.mark[1] == '-' ? '未指定' : params.row.mark[1]
            return h('span', ballNum)
          }
        },
        {
          title: '第三名',
          align: 'center',
          key: 'ball',
          render: (h, params) => {
            let ballNum = params.row.mark[2] == '-' ? '未指定' : params.row.mark[2]
            return h('span', ballNum)
          }
        },
        {
          title: '第四名',
          align: 'center',
          key: 'ball',
          render: (h, params) => {
            let ballNum = params.row.mark[3] == '-' ? '未指定' : params.row.mark[3]
            return h('span', ballNum)
          }
        },
        {
          title: '第五名',
          align: 'center',
          key: 'ball',
          render: (h, params) => {
            let ballNum = params.row.mark[4] == '-' ? '未指定' : params.row.mark[4]
            return h('span', ballNum)
          }
        },
        {
          title: '第六名',
          align: 'center',
          key: 'ball',
          render: (h, params) => {
            let ballNum = params.row.mark[5] == '-' ? '未指定' : params.row.mark[5]
            return h('span', ballNum)
          }
        },
        {
          title: '第七名',
          align: 'center',
          key: 'ball',
          render: (h, params) => {
            let ballNum = params.row.mark[6] == '-' ? '未指定' : params.row.mark[6]
            return h('span', ballNum)
          }
        },
        {
          title: '第八名',
          align: 'center',
          key: 'ball',
          render: (h, params) => {
            let ballNum = params.row.mark[7] == '-' ? '未指定' : params.row.mark[7]
            return h('span', ballNum)
          }
        },
        {
          title: '第九名',
          align: 'center',
          key: 'ball',
          render: (h, params) => {
            let ballNum = params.row.mark[8] == '-' ? '未指定' : params.row.mark[8]
            return h('span', ballNum)
          }
        },
        {
          title: '第十名',
          align: 'center',
          key: 'ball',
          render: (h, params) => {
            let ballNum = params.row.mark[9] == '-' ? '未指定' : params.row.mark[9]
            return h('span', ballNum)
          }
        },
        {
          title: '操作',
          align: 'center',
          width: '200',
          render: (h, params, index) => {
            let disable = params.row.mark.every(it => it == '-')
            return h('div', [
              h('Button', {
                class: {
                  'mr-1': true
                },
                props: {
                  type: 'warning'
                },
                on: {
                  click: () => this.$refs.DrawSettingTable.ModalClick(2, params.row.GPMId, params.row.period)
                }
              }, '修改'),
              h('Button', {
                class: {
                  'ml-1': true,
                  'setting-disabled': disable
                },
                props: {
                  type: 'error',
                  disabled: disable
                },
                on: {
                  click: () => {
                    this.delMarkPeriod(params.row.GPMId)
                  }
                }
              }, '删除设定')
            ])
          }
        }
      ]
    }
  },
  methods: {
    delAction () {
      this.$refs.DrawSettingTable.reload()
    }
  }
};
</script>